<template>
  <div class="page-not-found-container">
    <h1>PAGE NOT FOUND</h1>
    <div>URL: {{$route.fullPath}}</div>
    <img class="mt-4" src="https://media.giphy.com/media/14uQ3cOFteDaU/giphy.gif" />
    <a class="mt-4" href="#" @click.prevent="$router.go(-1)">Go back</a>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
  data() {
    return {};
  },
};
</script>

<style>
.page-not-found-container {
  background-color: #162643;
  color: white;
  height: 100vh;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}
.page-not-found-container > * {
  display: block;
  width: auto;
}
</style>
